import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { equipmentGroups } from '../data/content';
import Icon from './Icons';

/**
 * Rozbaľovací zoznam kompletnej výbavy vozidla.
 * Tlačidlo „Stiahnuť zoznam (PDF)" otvorí tlačový dialóg –
 * zákazník si zoznam uloží ako PDF cez „Uložiť ako PDF".
 */
export default function EquipmentChecklist({ label = 'Čo presne je vo výbave?' }) {
  const [open, setOpen] = useState(false);

  const handleDownload = () => {
    if (!open) setOpen(true);
    // Krátke oneskorenie, aby sa zoznam stihol rozbaliť pred tlačou.
    setTimeout(() => window.print(), 350);
  };

  return (
    <div className="equipment">
      <button
        className="equipment__toggle"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
        aria-controls="equipment-body"
      >
        <span>{label}</span>
        <Icon name="chevron" className="icon--chevron" />
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            id="equipment-body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: 'easeInOut' }}
            style={{ overflow: 'hidden' }}
          >
            <div className="equipment__body">
              {equipmentGroups.map((group) => (
                <div className="equipment__group" key={group.title}>
                  <h3>{group.title}</h3>
                  <ul>
                    {group.items.map((item) => (
                      <li key={item}>
                        <Icon name="check" size={16} />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="equipment__footer">
              <button className="btn btn--ghost" onClick={handleDownload}>
                <Icon name="download" size={18} />
                Stiahnuť zoznam (PDF)
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
